<p-panel header="Statistiken">
  <p-table
    responsiveLayout="stack"
    styleClass="p-datatable-striped"
    [value]="statistics"
    *ngIf="isStatisticsAvailable()"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>Runde</th>
        <th>Artikel-Info</th>
        <th>Schätzung Spieler 1</th>
        <th>Schätzung Spieler 2</th>
        <th>Amazon-Preis</th>
        <th>Differenz Spieler 1</th>
        <th>Differenz Spieler 2</th>
        <th>Senfkarte</th>
        <th>Gewinner</th>
        <th>Gewonnene Punkte</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-statistic let-columns="columns">
      <tr>
        <td><span class="p-column-title">Runde</span>{{ statistic.round }}</td>
        <td>
          <span class="p-column-title">Artikel-Info</span>
          <p-button
            (click)="
              showArticleInfoDialog(
                statistic.articleUrl,
                statistic.articleTitle
              )
            "
            icon="pi pi-info-circle"
          ></p-button>
        </td>
        <td>
          <span class="p-column-title">Schätzung Spieler 1</span
          >{{ statistic.estimatedPricePlayer1 | currency: "EUR" }}
        </td>
        <td>
          <span class="p-column-title">Schätzung Spieler 2</span
          >{{ statistic.estimatedPricePlayer2 | currency: "EUR" }}
        </td>
        <td>
          <span class="p-column-title">Amazon-Preis</span
          >{{ statistic.priceAmazon | currency: "EUR" }}
        </td>
        <td>
          <span class="p-column-title">Differenz Spieler 1</span
          >{{ statistic.differencePricePlayer1 | currency: "EUR" }}
        </td>
        <td>
          <span class="p-column-title">Differenz Spieler 2</span
          >{{ statistic.differencePricePlayer2 | currency: "EUR" }}
        </td>
        <td>
          <span class="p-column-title">Senfkarte</span
          >{{ mapSenfkarteState(statistic.senfkarteUsed) }}
        </td>
        <td>
          <span class="p-column-title">Gewinner</span
          >{{ mapWinner(statistic.winner) }}
        </td>
        <td>
          <span class="p-column-title">Gewonnene Punkte</span
          >{{ statistic.points }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>

<p-dialog [(visible)]="displayArticleInfoDialog">
  <ng-template pTemplate="header"> Artikeldaten </ng-template>
  <p>{{ statisticArticleTitle }}</p>
  <p>
    <a href="{{ statisticArticleUrl }}" target="_blank">{{
      statisticArticleUrl
    }}</a>
  </p>
</p-dialog>
